<template>
  <div>
    <div class="content-box">
      <h3>账户预存</h3>
      <div class="content-from" v-if="detail">
        <el-form :model="fromData" :inline="true" label-width="130px">
          <el-form-item
            label="预付款充值金额:"
            prop="dealAmount"
            :rules="{ required: true, message: '请输入充值金额', trigger: 'blur' }"
          >
            <el-input
              v-model="fromData.dealAmount"
              placeholder="请输入金额"
              type="number"
              @input="ruleNumber"
            ></el-input>
            <span class="money_text">
              账户余额:
              <b style="color:#ff7e00">￥{{detail.balanceAmountText}}</b>
            </span>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input type="textarea" :rows="4" placeholder="请输入备注" v-model="fromData.remark"></el-input>
          </el-form-item>
        </el-form>
        <div class="content_btn">
          <p>1、"预付款充值"是直接转账至签约方的预付账款；</p>
          <p>2、预付账款可线下联系交易方客服申请退回。</p>
          <el-button size="small" type="success" @click="next">下一步</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import createRechargeOrder from "@/lib/data-service/default/wallet_order_createRechargeOrder";
import queryAccountDetail from "@/lib/data-service/default/wallet_account_queryAccountDetail";
export default {
  name: "account-deposit",
  data() {
    return {
      fromData: {},
      rule: {},
      detail: null
    };
  },
  methods: {
    next() {
      if (!this.fromData.dealAmount || this.fromData.dealAmount == 0) return;
      // if (this.fromData.dealAmount)
      createRechargeOrder(this.fromData).then(res => {
        let orderId = res.orderId;
        this.$router.push({
          name: "distributor-account-pay",
          query: { orderId }
        });
      });
    },
    ruleNumber(val) {
      if (!val) return;
      this.fromData.dealAmount = val.match(/^[0-9]+\.?\d{0,2}/)
        ? val.match(/^[0-9]+\.?\d{0,2}/)[0]
        : 1;
    },
    getBalance() {
      queryAccountDetail().then(res => {
        this.detail = res;
      });
    }
  },
  activated() {
    this.fromData = {};
    this.getBalance();
  }
};
</script>
<style lang="less" scoped>
.content-box {
  h3 {
    background: #f4f9ff;
    padding: 8px 30px;
    color: #4b4b4b;
    position: relative;
    &::after {
      content: "";
      display: block;
      width: 4px;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: #237dc8;
    }
  }
  /deep/.el-form {
    .el-form-item {
      display: flex;
    }
  }
  .content-from {
    width: 50%;
    margin: 20px 35px 0 0;
  }
  /deep/.el-input {
    width: 100%;
    input {
      border-radius: 0;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    input[type="number"] {
      -moz-appearance: textfield;
    }
  }
  /deep/.el-button {
    border-radius: 0;
  }
  .money_text {
    color: #666;
  }
}
.content_btn {
  margin-left: 26%;
  p {
    font-size: 14px;
    color: red;
    line-height: 23px;
  }
  .el-button {
    margin-top: 10px;
  }
}
</style>